import { SignupForm } from "../../../../src/components/signup";
import * as React from 'react';
export default {
  SignupForm,
  React
};